// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './DocumentModeCanvasReadingLineDebugger.scss';

const getLineStyle = ({ top, left, gridSize }) => ({
    top: top * gridSize,
    left: left * gridSize,
});

const DocumentModeCanvasReadingLineDebugger = (props) => {
    const { className, order, start, end, gridSize } = props;

    const width = Math.abs(end.x - start.x) * gridSize;
    const height = Math.max(2, Math.abs(end.y - start.y)) * gridSize + 10;

    const top = Math.min(start.y, end.y) - 1;
    const left = Math.min(start.x, end.x);

    const x1 = (start.x - left) * gridSize;
    const x2 = (end.x - left) * gridSize;

    const y1 = (start.y - top) * gridSize;
    const y2 = (end.y - top) * gridSize;

    return (
        <div
            className={classNames('DocumentModeCanvasReadingLineDebugger', className)}
            style={getLineStyle({ top, left, gridSize })}
        >
            <div className="order-marker">
                <span className="text">{order}</span>
            </div>
            <svg className="line" version="1.1" width={width} height={height}>
                <defs>
                    <marker
                        id="arrow"
                        className="arrow"
                        markerWidth="5"
                        markerHeight="5"
                        refX="5"
                        refY="2"
                        orient="auto"
                        markerUnits="strokeWidth"
                    >
                        <path d="M0,0 L0,4 L6,2 z" />
                    </marker>
                </defs>
                <line x1={x1} x2={x2} y1={y1} y2={y2} fill="transparent" markerEnd="url(#arrow)" />
            </svg>
        </div>
    );
};

DocumentModeCanvasReadingLineDebugger.propTypes = {
    gridSize: PropTypes.number.isRequired,
    order: PropTypes.number.isRequired,
    start: PropTypes.object.isRequired,
    end: PropTypes.object.isRequired,
    className: PropTypes.string,
};

export default DocumentModeCanvasReadingLineDebugger;
